import PasswordInput from './PasswordInput';

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/PasswordInput/index.js